var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
      ("type-" + _vm.type),
      ("size-" + _vm.size) ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('div',{staticClass:"icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),(_vm.text)?_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }